import { ReactNode, useEffect } from 'react';

// Material UI Components
import LinearProgress from '@mui/material/LinearProgress';
import Container from '@mui/material/Container';
import { Theme } from '@mui/material/styles';

// Project Components
import Footer from 'components/navigation/Footer';
import TopBar from 'components/navigation/TopBar';
import SkipToContent from 'components/navigation/SkipToContent';

export type NavigationProps = {
  children?: ReactNode;
  isLoading?: boolean;
  noFooter?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
};

const containerSx = (theme: Theme) => ({
  [theme.breakpoints.down('md')]: {
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
});

const Navigation = ({ children, isLoading, noFooter, maxWidth = 'xl' }: NavigationProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SkipToContent />
      <TopBar />
      <main id={'main'} style={{ minHeight: '101vh' }}>
        {maxWidth === false ? (
          isLoading ? (
            <LinearProgress />
          ) : (
            <>{children}</>
          )
        ) : (
          <Container maxWidth={maxWidth} sx={containerSx}>
            {isLoading ? <LinearProgress /> : <>{children}</>}
          </Container>
        )}
      </main>
      {!noFooter &&
        !isLoading &&
        (maxWidth === false ? (
          <Footer />
        ) : (
          <Container maxWidth={'xl'} sx={containerSx}>
            <Footer />
          </Container>
        ))}
    </>
  );
};

export default Navigation;
